export const OnlineItemListColConfig = [
    {
        "label_of_column": "Type",
        "name_of_db_column": "type",
        "order_of_column": 1,
    },
    {
        "label_of_column": "Item",
        "name_of_db_column": "item",
        "order_of_column": 2,
    },
    {
        "label_of_column": "Product ID",
        "name_of_db_column": "productId",
        "order_of_column": 3,
    },
    {
        "label_of_column": "Ordered",
        "name_of_db_column": "requestedQuantity",
        "order_of_column": 4,
    },
    {
        "label_of_column": "Confirmed",
        "name_of_db_column": "confirmedQuantity",
        "order_of_column": 5,
    },
    {
        "label_of_column": "Changed",
        "name_of_db_column": "changed",
        "order_of_column": 6,
    },
    {
        "label_of_column": "Unit Price",
        "name_of_db_column": "unitPrice",
        "order_of_column": 7,
    },
    {
        "label_of_column": "Material UOM",
        "name_of_db_column": "materialUom",
        "order_of_column": 8,
    },
    {
        "label_of_column": "Grand Total",
        "name_of_db_column": "grandTotal",
        "order_of_column": 9,
    },
  ]
  